var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"grey lighten-4"},[_c('HybridNavbar'),_c('v-container',{staticClass:"mx4 mb-4"},[_c('router-view')],1),_c('processing-station'),_c('all-notification-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }